module.exports = "<lfwms-result-data-table [searchService]=\"searchService\" [tableMode]=\"searchService.displayMode\" (buttonActionHandler)=\"buttonService.handleMainButtonPanelActionsForTable($event, widgetConfig.id)\"></lfwms-result-data-table>\n    "


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/components/widget/advance-configuration-table-widget/advance-configuration-table-widget.html
// module id = ../../../../../src/app/shared/components/widget/advance-configuration-table-widget/advance-configuration-table-widget.html
// module chunks = main